module.exports = __webpack_public_path__ + "img/jo.ed3f2b2f.svg";